/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

import {store} from './client-create-app';

// Keep track of the current state.
const awayTime = 300000;
let away = false;
let lastEvent = Date.now();

/**
 * Update last event time.
 * This is made global so Game.vue can update it was well.
 */
window.updateLastEvent = () => {
  lastEvent = Date.now();

  // If they are away, set them as not away.
  if (away) {
    away = false;
    store.dispatch('setAway', false);
  }
};

/**
 * Check if user has been away too long and send request to go away.
 */
const checkAway = () => {
  if (!away && Date.now() - awayTime > lastEvent) { // 5 minutes
    away = true;
    store.dispatch('setAway', true);
  }

  // Setup timeout to check periodically if we are away.
  setTimeout(checkAway, 10000);
};

checkAway();

// Setup event listeners to keep the last event time updated.
window.addEventListener('mousemove', window.updateLastEvent, false);
window.addEventListener('keyup', window.updateLastEvent, false);
window.addEventListener('touchstart', window.updateLastEvent, false);

export default {};
